var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "root",
      class: { "md-up": _vm.$wf.isMdUp },
      attrs: { "max-width": "900" },
    },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { staticClass: "scroll-view", attrs: { tag: "w-card-content", x: "" } },
        [_c("w-json-viewer", { attrs: { value: _vm.value } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }